import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    let settings = data?.[0] ?? {}
    return {
      id: settings.id ?? null,
      from: settings.sending_window?.from ?? null,
      to: settings.sending_window?.to ?? null,
      allowed_days: settings.sending_window?.allowed_days ?? [],
      flags:
        settings.flags?.length > 0
          ? settings.flags
          : [
              {
                flag: 'same_day_appointment',
                value: false,
                text: 'Skip sending comms for multiple appointments on the same day',
              },
            ],
    }
  }, [data])
}
